import 'whatwg-fetch';
import CasualSignupForm from './CasualSignupForm.svelte';

const casualpm_signup_form_target = document.getElementById("signup-form-wrapper");

const productFromData = casualpm_signup_form_target.dataset.product;
const product = productFromData ? productFromData : (new URLSearchParams(document.location.search)).get("plan");

const casualpm_signup_form = new CasualSignupForm({
    target: casualpm_signup_form_target,
    props: {
        product: product,
        coupon: casualpm_signup_form_target.dataset.coupon
    }
});

export default casualpm_signup_form;
